import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderFlowmonResearchAndProjects extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
  }

  getItemHtml(item, relatedMedia) {
    const html = `
    <div class="col-6 -l-full">
      <div class="Card Elevated">
        <div>
          <h2 class="h4-alt">
            <a href="${window.location.pathname}/${item.UrlName}" class="HoverBox">
              ${this.encodeHtml(item.Title)}
            </a>
          </h2>
          <div class="-fs17">${item.Summary}</div>
        </div>
      </div>
    </div>
  `;
    return html;
  }
}
